import { createContext } from "react";
import type { TrainingApi } from "./types";

/** null: no injected API (the app builds the default one in useTrainingApi). */
export const TrainingApiContext = createContext<TrainingApi | null>(null);
